'use strict';
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024 from "./dev.cheleb.scalamigen.-Form$.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13() {
}
export { $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13 as $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13 };
$p = $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13() {
}
export { $h_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13 as $h_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13 };
$h_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.h = (function() {
  return $j_dev$002echeleb$002escalamigen$002e$002dForm$0024.$m_Ldev_cheleb_scalamigen_Form$().eU();
});
var $d_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13, "samples.Persons$package$$anon$7$$anon$12$$anon$13", ({
  q1: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13 as $d_Lsamples_Persons$package$$anon$7$$anon$12$$anon$13 };
